// Ensure SSR is enabled for all trail routes
export const ssr = true;

// Allow prerendering where it makes sense
export const prerender = false;

// This ensures client-side navigation still works
export const csr = true; 